// extracted by mini-css-extract-plugin
export default {"afterPayModeSection":"a8-z","refreshPageWarning":"b8-z","redirectMessageText":"c8-z"};